import React, { useContext, useState } from 'react'
import { Button, Col, Row, Typography } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import useHideMenu from '../hooks/useHideMenu'
import { SocketContext } from '../context/SocketContext'

const { Title, Text } = Typography

const NewTicket = () => {

    useHideMenu(true)

    const { socket } = useContext(SocketContext)
    const [ticket, setTicket] = useState(null)

    const newTicket = () => {
        socket.emit('request-ticket', null, (newTicket) => {
            setTicket(newTicket)
        })
    }

    return (
        <>
            <Row>
                <Col span={14} offset={5} align="center">
                    <Title level={3}>Press the button to generate a new ticket</Title>
                    <Button
                        type="primary"
                        shape="round"
                        size="large"
                        icon={<DownloadOutlined />}
                        onClick={newTicket}
                    >
                        New Ticket
                    </Button>
                </Col>
            </Row>

            { ticket && (
                <Row style={{ marginTop: 100 }}>
                    <Col span={14} offset={5} align="center">
                        <Text className="text3">Your number</Text>
                        <br />
                        <Text type="success" style={{ fontSize: 55 }}>
                            {ticket.number}
                        </Text>
                    </Col>
                </Row>
            )}
        </>
    )
}

export default NewTicket